import * as React from "react";
const SvgAdd3 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.8235 18.8235V11.7647H21.1765V18.8235H28.2353V21.1765H21.1765V28.2353H18.8235V21.1765H11.7647V18.8235H18.8235Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }));
export default SvgAdd3;
